import { render, staticRenderFns } from "./wl-upload-image.vue?vue&type=template&id=204a958a&scoped=true&lang=pug"
import script from "./wl-upload-image.js?vue&type=script&lang=js&external"
export * from "./wl-upload-image.js?vue&type=script&lang=js&external"
import style0 from "./wl-upload-image.styl?vue&type=style&index=0&id=204a958a&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204a958a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('204a958a')) {
      api.createRecord('204a958a', component.options)
    } else {
      api.reload('204a958a', component.options)
    }
    module.hot.accept("./wl-upload-image.vue?vue&type=template&id=204a958a&scoped=true&lang=pug", function () {
      api.rerender('204a958a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wl-component-gallery/wl-upload-image/wl-upload-image.vue"
export default component.exports